import getLocale from './getLocale';
import { currencyMap } from './currency-map';

/**
 * Return a currency based on a given locale (or user's browser's locale)
 * (i.e. 'en-US' -> 'USD')
 * @param locale: string
 * @return string
 */
export default function (locale: string): string {
  if (!locale) {
    locale = getLocale();
  }

  const countryCode = getCountryCode(locale)?.toUpperCase();

  if (countryCode && countryCode in currencyMap) {
    return currencyMap[countryCode];
  }

  console.warn(`Currency not found for locale ${locale} and country code ${countryCode}`);

  return 'USD';
}

// Get the country code from locale
// (i.e. 'en-US' -> 'en')
function getCountryCode(localeString: string): string | undefined {
  let components = localeString.split('_');
  if (components.length === 2) {
    return components.pop();
  }

  components = localeString.split('-');
  if (components.length === 2) {
    return components.pop();
  }

  return localeString;
}
